<template>
  <div class="dbc-c-multiteaser__element">
    <div v-if="teaser.video" class="mb-4">
      <UtilityVideo
        :id="teaser.video.video_id"
        :title="teaser.video.title"
        :consentLayer="teaser.video.consent_layer"
        :format="teaser.image_format || 'f4-3'"
      />
    </div>
    <div v-else-if="teaser.image">
      <NuxtLink
        v-if="teaser.image_link"
        :to="teaser.image_link"
        :target="resolveLinkTarget(teaser.image_link)"
      >
        <div class="dbc-c-multiteaser__image">
          <UtilityImage
            :format="teaser.image_format"
            :src="teaser.image[0]?.url"
            :alt="teaser.image_alt"
            :width="teaser.image[0]?.width"
            :height="teaser.image[0]?.height"
            loading="lazy"
            :copyright="teaser.image_copyright"
          />
        </div>
      </NuxtLink>
      <div v-else class="dbc-c-multiteaser__image">
        <UtilityImage
          :format="teaser.image_format"
          :src="teaser.image[0]?.url"
          :alt="teaser.image_alt"
          :width="teaser.image[0]?.width"
          :height="teaser.image[0]?.height"
          loading="lazy"
          :copyright="teaser.image_copyright"
        />
      </div>
    </div>

    <UtilityHeadline
      v-if="teaser.headline_h3"
      :class="`dbc-text-color-${teaser.headline_h3}`"
      :text="teaser.headline_h3"
      :level="3"
      :category="{ text: teaser.category }"
    />

    <UtilityText v-if="teaser.text" :text="teaser.text" />

    <UtilityButton
      v-if="teaser.cta_text && teaser.cta_link"
      :button="{ type: 'text', link: teaser.cta_link, text: teaser.cta_text }"
    />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  teaser: Teaser
}>()
</script>
